"use client";
import Button from "@/components/ui/Button";
import { useTranslations } from "@/i18n/client";
import styles from "./index.module.css";

export const ChangePasswordCTA = () => {
  const t = useTranslations();
  return (
    <div className={styles.changePasswordContainer}>
      <div>
        <h2 className={styles.changePasswordTitle}>
          {t("myAccount.accountPage.accountInfo.changePassword")}
        </h2>
        <p>{t("myAccount.accountPage.accountInfo.changePasswordText")}</p>
      </div>

      <Button
        className={styles.changePasswordButton}
        type="button"
        href="/account/change-password"
      >
        {t("myAccount.accountPage.accountInfo.changePassword")}
      </Button>
    </div>
  );
};
